import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Badge "agente libre" : joueur sans contrat actif.
// Pensé pour être rendu au même niveau que le badge ACB (rankings / suivis).
const FreeAgentBadge = ({ compact = false }) => {
  const { t } = useTranslation();
  const label = t('createPlayer.fields.freeAgentBadge');

  return (
    <Tooltip arrow title={label}>
      <Chip
        label={label}
        size="small"
        sx={{
          backgroundColor: '#4caf50',
          color: '#fff',
          fontWeight: 'bold',
          height: compact ? 18 : 22,
          fontSize: compact ? '0.65rem' : '0.75rem',
          maxWidth: 150,
          '& .MuiChip-label': {
            px: compact ? 0.5 : 0.75,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }
        }}
      />
    </Tooltip>
  );
};

export default FreeAgentBadge;
